import * as React from 'react';
import { IDropDownMenuProps } from '../../../DropDownMenu.types';
import MenuButton from '../../../../MenuButton/viewer/skinComps/SeparateShinyIIMenuButtonNSkin/SeparateShinyIIMenuButtonNSkin';
import SeparateShinyIIMenuButton from './SeparateShinyIIMenuButton';
import styles from './SeparateShinyIIMenuButtonSkin.scss';

const SeparateShinyIIMenuButtonSkin: React.FC<IDropDownMenuProps> = props => {
  return (
    <SeparateShinyIIMenuButton {...props} styles={styles} Button={MenuButton} />
  );
};

export default SeparateShinyIIMenuButtonSkin;
